 <template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">应急统计</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="开始时间">
            <el-date-picker
              v-model="date_start"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="expireTimeOption"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker
              v-model="date_end"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="expireTimeOption"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="echart">
          <div class="echart_1">
            <div>
              <LineEchart
                :chartData="eventData"
                :title="title"
                seriesName="应急事件"
                yAxisName="数量（件）"
                xAxisName="日期"
                unit="件"
              ></LineEchart>
            </div>
            <div>
              <BarEchart
                :chartData="eventTimeData"
                :title="timeTitle"
                seriesName="数量（件）"
                yAxisName="数量（件）"
                xAxisName="类型"
              ></BarEchart>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
import linechart from "@/views/echart/LineEchart";
import barchart from "@/views/echart/BarEchart";
import barchart2 from "@/views/echart/BarEchart2";
const utils = ZJApp.ZJUtils;
export default {
  name: "EmergencyAnalysisView",
  controller: "UI",
  action: "EmergencyAnalysisView",
  components: {
    linechart,
    barchart,
    barchart2,
  },
  data() {
    return {
      date_start: null,
      date_end: null,
      expireTimeOption: {
        disabledDate(date) {
          // disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() >= Date.now();
        },
      },
      eventData: {
        xData: [],
        yData: [],
      },
      eventTimeData: {
        xData: [],
        yData: [],
      },
      title: "应急事件0",
      timeTitle: "平均应急时间0小时",

      evenTypes: [],
    };
  },
  mounted: function () {
    this.getTime(5);
    this.basedatabind();
    this.logInfo.ActionName = "应急统计查看";
    this.logInfo.LogMessage = "应急统计查看";
    this.logInfo.ModuleName = "应急指挥";
    this.logInfo.PageName = "应急统计页";
    this.addOperationLog();
    // this.getData(0);
  },
  methods: {
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = "加载中...";
      return utils
        .waitAll([this.config.getUValue("EmergencyService:FitEventType:", "")])
        .then((r) => {
          //所属应急事件类型
          this.evenTypes = r[0].JValue;

          this.loading = false;
          this.search();
          return r;
        })
        .catch((e) => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    // 点击查询按钮
    onSearch() {
      if (new Date(this.date_end) < new Date(this.date_start)) {
        this.$message.error("结束时间应该大于开始时间");
        return;
      }

      this.search();
    },
    onCancel() {
      this.getTime(5);
      this.search();
    },
    getTime(value) {
      var day = new Date();
      this.date_end = day.format("yyyy-MM-dd");
      if (value == -1) {
        day.setTime(day.getTime() - 1 * 24 * 60 * 60 * 1000);
        this.date_start = day.format("yyyy-MM-dd");
      }
      if (value == 0) {
        this.date_start = this.date_end;
      }
      if (value == 1) {
        day.setTime(day.getTime() - 7 * 24 * 60 * 60 * 1000);
        this.date_start = day.format("yyyy-MM-dd");
      }
      if (value == 2) {
        day.setTime(day.getTime() - 30 * 24 * 60 * 60 * 1000);
        this.date_start = day.format("yyyy-MM-dd");
      }
      if (value == 3) {
        day.setTime(day.getTime() - 180 * 24 * 60 * 60 * 1000);
        this.date_start = day.format("yyyy-MM-dd");
      }
      if (value == 4) {
        this.date_start = day.getFullYear() + "-" + "01" + "-" + "01";
      }
      if (value == 5) {
        this.date_start = day.format("yyyy-MM-01");
      }
    },
    search() {
      let searchInfo = {
        BeginDate: this.date_start,
        EndDate: new Date(this.date_end).format("yyyy-MM-dd 23:59"),
      };
      this.searching = true;
      return new MyApis.EmergencyEventApi()
        .GetEventReport(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.title = "应急事件" + (r.EventTotal || 0) + "件";
          this.timeTitle = "平均应急时间" + (r.AvgTime || 0) + "小时";
          if (r && r.EventCountByDayTrend) {
            let days = [],
              data = [];
            r.EventCountByDayTrend.forEach((item) => {
              days.push(item.DName);
              data.push(item.Count);
            });
            this.eventData.xData = days;
            this.eventData.yData = data;
          }
          let tempEvenTypes = this.evenTypes;
          let typeDays = [],
            typeData = [];
          if (r && r.EventCountByTypeTrend) {
            r.EventCountByTypeTrend.forEach((item) => {
              const typeName = this.evenTypes.filter((it) => {
                return it.ItemKey === item.DName;
              });
              tempEvenTypes = this.evenTypes.map((ele) => {
                if (ele.ItemKey === item.DName) {
                  ele.hasValue = true;
                } else {
                  ele.hasValue = false;
                }
                return ele;
              });
              item.TypeName = typeName[0].Description;

              typeDays.push(item.TypeName);
              typeData.push(item.Count);
            });
          }
          tempEvenTypes.forEach((elem) => {
            if (!elem.hasValue) {
              typeDays.push(elem.Description);
              typeData.push(0);
            }
          });
          this.eventTimeData.xData = typeDays;
          this.eventTimeData.yData = typeData;
          this.searching = false;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.searching = false;
        });
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    day() {
      this.getData(0);
      this.getTime(0);
    },
    week() {
      this.getData(1);
      this.getTime(1);
    },
    month() {
      this.getData(2);
      this.getTime(2);
    },
    half() {
      this.getData(3);
      this.getTime(3);
    },
    year() {
      this.getData(4);
      this.getTime(4);
    },
  },
};
</script>

<style scoped lang="scss">
.datelabel {
  border-right: 3px solid #2bc5ff;
  padding: 0 1rem;
}
.echart {
  position: relative;
  width: 100%;
  height: 100%;
}
.echart_1,
.echart_2 {
  width: 100%;
  height: 90%;
}
.echart_1 {
  margin-bottom: 15px;
}
.echart_2 {
  margin-top: 15px;
}
.echart_1 > div,
.echart_2 > div {
  float: left;
  width: 50%;
  height: 100%;
  color: #2bc5ff;
  font-weight: bold;
}
</style>